export default "<router-outlet (activate)=\"onRouterOutletActivate($event)\"></router-outlet>"